// extracted by mini-css-extract-plugin
export var rateTable = "_44-0";